import script from "./ManageCustomBarcodes.vue?vue&type=script&setup=true&lang=js"
export * from "./ManageCustomBarcodes.vue?vue&type=script&setup=true&lang=js"

import "./ManageCustomBarcodes.vue?vue&type=style&index=0&id=7b50c3bb&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7b50c3bb"]])

export default __exports__